rdefine('app/products/models/Product',['backbone'],function(Backbone) {
    return Backbone.Ribs.Model.extend({
        defaults:{
            lang:{}
        },
        initialize:function() {
            console.log('product init with',this.model);
        }
    });
});